import { useEffect, useState, useCallback } from "react";
import newRequest from "../context/newRequest";

const defaultRegions = [
  { id: "JABODETABEK", description: "JABODETABEK" },
  { id: "Jakarta", description: "Jakarta" },
  { id: "Jawa Barat", description: "Jawa Barat" },
  { id: "Jawa Timur", description: "Jawa Timur" },
  { id: "Jawa Tengah", description: "Jawa Tengah" },
  { id: "Banten", description: "Banten" },
  { id: "Lampung", description: "Lampung" },
  { id: "Bali", description: "Bali" },
  { id: "Yogyakarta", description: "Yogyakarta" },
  { id: "Sulawesi", description: "Sulawesi" },
];

export const useRegions = () => {
  const [regions, setRegions] = useState(defaultRegions);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRegions = useCallback(async () => {
    setLoading(true);
    try {
      const res = await newRequest.get("/regions");
      const list = res.data && res.data.data;
      if (Array.isArray(list) && list.length > 0) {
        setRegions(list);
      }
    } catch (err) {
      console.warn("Could not fetch regions from API, using defaults:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRegions();
  }, [fetchRegions]);

  return { regions, loading, error, refreshRegions: fetchRegions };
};

export default useRegions;
